"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import { jsx, jsxs } from "react/jsx-runtime";
import s from "underscore.string";
import React from "react";
import _ from "underscore";
import Auth from "../util/auth";
import Api from "../api/api";
import classNames from "classnames";
import DisablingButton from "../components/disabling_button";
import DocumentThumbnail from "./document_thumbnail";
import EmailTypeAhead from "./email_typeahead";
import WaitingSpinner from "../components/waiting_spinner";
import BouncesMessage from "./bounces_message";
import LoadEmailCreator from "./load_email_creator";
function replaceNoReplyRecipientsWithPreferredRecipient(recipients, factoringCompany) {
  if (factoringCompany && factoringCompany.settings) {
    const noReplyEmailAddresses = factoringCompany.settings.no_reply_email_addresses || [];
    const preferredReplyEmailAddress = factoringCompany.settings.preferred_reply_email_address;
    let recipientsList = recipients.split(", ");
    recipientsList = recipientsList.map((recipient) => {
      if (noReplyEmailAddresses.includes(recipient)) {
        return preferredReplyEmailAddress;
      } else {
        return recipient;
      }
    });
    recipients = recipientsList.join(", ");
  }
  return recipients;
}
function noDefaultSenderEnabled() {
  var settings = Api.Account.currentSettings();
  return settings && settings.disable_carrier_as_default_exception_recipient;
}
function enableDocuments(props) {
  var newState = {};
  _.each(props.documents || [], function(doc) {
    newState[doc.id] = false;
  });
  return newState;
}
function showPaymentsNetworkExceptionSender(props) {
  return Boolean(
    props.carrierInvoice && props.carrierInvoice.is_payments_network_submission
  );
}
function splitRecipients(state) {
  return _.compact(state.recipients.split(", "));
}
function maybeGetRecipients(props, state) {
  return showPaymentsNetworkExceptionSender(props) ? [] : splitRecipients(state);
}
function possibleCancel(props) {
  if (props.canCancel) {
    return /* @__PURE__ */ jsxs("span", { className: "button--cancel-wrapper", children: [
      /* @__PURE__ */ jsx("span", { className: "button__cancel-wrapper-or", children: "or " }),
      /* @__PURE__ */ jsx("button", { className: "button--cancel", onClick: props.cancel, children: "cancel" })
    ] });
  }
}
function selectedDocumentIds(props, state) {
  return _.pluck(
    _.select(props.documents || [], (doc) => {
      return !state[doc.id];
    }),
    "id"
  );
}
function onComplete(props) {
  if (props.toDashboardOrNextGroup) {
    props.toDashboardOrNextGroup();
  } else if (props.onComplete) {
    props.onComplete();
  }
}
function allRecipients(state) {
  return state.recipients;
}
function validEmail(state) {
  return !s.isBlank(allRecipients(state));
}
function validPayeeMessage(state) {
  return !s.isBlank(state.body);
}
function documentSelected(state, docId) {
  return !state[docId];
}
function allDocumentsSelected(props, state) {
  return _.all(props.documents || [], (doc) => {
    return documentSelected(state, doc.id);
  });
}
function noDocumentsSelected(props, state) {
  return _.all(props.documents || [], (doc) => {
    return !documentSelected(state, doc.id);
  });
}
function getEmailFromTemplate(props, templateId, defaultEmail) {
  if (!props.multipleExceptionMessagesEnabled) {
    return defaultEmail;
  }
  const selectedTemplate = (props.customEmailTemplates || []).find(
    (template) => template.id.toString() === templateId
  );
  if (selectedTemplate) {
    const email = props.renderTemplate ? props.renderTemplate(selectedTemplate.subject, selectedTemplate.body) : LoadEmailCreator(
      props.possibleLoad,
      props.carrierInvoice,
      Auth._currentUser,
      selectedTemplate.subject,
      selectedTemplate.body,
      props.templateVariables,
      props.carrier
    ).initialEmail();
    return {
      selectedTemplate: selectedTemplate.id.toString(),
      subject: email.subject,
      body: email.body
    };
  } else {
    return defaultEmail;
  }
}
function renderTemplateOptions(props) {
  if (!props.multipleExceptionMessagesEnabled || !props.customEmailTemplates) {
    return null;
  }
  return props.customEmailTemplates.map((template) => /* @__PURE__ */ jsx("option", { value: template.id, children: template.name }, template.id));
}
var ExceptionSender = React.createClass({
  getDefaultProps: function() {
    return {
      multipleExceptionMessagesEnabled: false,
      customEmailTemplates: []
    };
  },
  getInitialState: function() {
    var _a, _b, _c;
    const sendNoteToPayeeDefault = showPaymentsNetworkExceptionSender(
      this.props
    );
    let recipients = ((_a = this.props.parent) == null ? void 0 : _a.sender_address) || "";
    const factoringCompany = this.props.factoringCompany;
    recipients = replaceNoReplyRecipientsWithPreferredRecipient(
      recipients,
      factoringCompany
    );
    const defaultCustomTemplateId = this.props.multipleExceptionMessagesEnabled && this.props.customEmailTemplates && this.props.customEmailTemplates.length > 0 ? (_c = (_b = this.props.customEmailTemplates.find((template) => template.is_default)) == null ? void 0 : _b.id) == null ? void 0 : _c.toString() : "";
    const exceptionEmail = getEmailFromTemplate(
      this.props,
      defaultCustomTemplateId,
      {
        selectedTemplate: "",
        subject: this.props.defaultEmail.subject,
        body: this.props.defaultEmail.body
      }
    );
    return {
      selectedTemplate: exceptionEmail.selectedTemplate,
      subject: exceptionEmail.subject,
      body: exceptionEmail.body,
      recipients,
      sendEmail: !sendNoteToPayeeDefault,
      sendNoteToPayee: sendNoteToPayeeDefault
    };
  },
  componentWillReceiveProps: function(newProps) {
    if (this.props.factoringCompany !== newProps.factoringCompany && newProps.factoringCompany) {
      let recipients = this.state.recipients;
      const factoringCompany = newProps.factoringCompany;
      recipients = replaceNoReplyRecipientsWithPreferredRecipient(
        recipients,
        factoringCompany
      );
      this.setState({ recipients });
    }
  },
  documentToggled: function(doc) {
    var newState = {};
    newState[doc.id] = !this.state[doc.id];
    this.setState(newState);
  },
  setSendEmail: function() {
    this.setState({ sendEmail: true, sendNoteToPayee: false });
  },
  setPrivateNote: function() {
    this.setState({ sendEmail: false, sendNoteToPayee: false });
  },
  setSendNoteToPayee: function() {
    var newState = { sendNoteToPayee: true, sendEmail: false };
    newState = __spreadValues(__spreadValues({}, newState), enableDocuments(this.props));
    this.setState(newState);
  },
  render: function() {
    return /* @__PURE__ */ jsx(WaitingSpinner, { "data-component": "ExceptionSender", when: this.state.saving, children: /* @__PURE__ */ jsx("div", { className: "exception-sender", children: /* @__PURE__ */ jsxs("div", { className: "row", children: [
      this.possibleNoteOrEmailSelection(),
      this.possibleSendEmail(),
      this.possiblePrivateNote(),
      this.possibleSendNoteToPayee()
    ] }) }) });
  },
  possibleNoteOrEmailSelection: function() {
    if (!this.props.messageSent && !this.props.ignored) {
      return /* @__PURE__ */ jsxs("div", { className: "exception-sender__note-or-email-selection", children: [
        /* @__PURE__ */ jsx("div", { className: "small-10 column", children: this.possibleSendNoteToPayeeToggle() }),
        /* @__PURE__ */ jsxs("div", { className: "small-10 column", children: [
          /* @__PURE__ */ jsx(
            "input",
            {
              id: "send-exception-email",
              type: "radio",
              checked: this.state.sendEmail,
              onChange: this.setSendEmail
            }
          ),
          /* @__PURE__ */ jsx("label", { htmlFor: "send-exception-email", children: showPaymentsNetworkExceptionSender(this.props) ? "Send an internal email" : "Send an email" })
        ] }),
        /* @__PURE__ */ jsxs("div", { className: "small-10 column", children: [
          /* @__PURE__ */ jsx(
            "input",
            {
              id: "save-without-emailing",
              type: "radio",
              checked: !this.state.sendEmail && !this.state.sendNoteToPayee,
              onChange: this.setPrivateNote
            }
          ),
          /* @__PURE__ */ jsx("label", { htmlFor: "save-without-emailing", children: "Save note and move to waiting without sending an email" })
        ] })
      ] });
    }
  },
  possibleSendNoteToPayeeToggle: function() {
    if (showPaymentsNetworkExceptionSender(this.props)) {
      const payee = this.props.carrierInvoice.payments_network_payee_name;
      const toggleTitle = "Send to " + payee + " through Payments Network";
      return /* @__PURE__ */ jsxs("div", { children: [
        /* @__PURE__ */ jsx(
          "input",
          {
            id: "send-payments-network-email",
            type: "radio",
            checked: this.state.sendNoteToPayee,
            onChange: this.setSendNoteToPayee
          }
        ),
        /* @__PURE__ */ jsx("label", { htmlFor: "send-payments-network-email", children: toggleTitle })
      ] });
    }
  },
  privateNoteFields: function() {
    return /* @__PURE__ */ jsxs("div", { children: [
      /* @__PURE__ */ jsxs("div", { className: "small-6 column", children: [
        /* @__PURE__ */ jsx("label", { children: "Private Note" }),
        /* @__PURE__ */ jsx(
          "input",
          {
            type: "text",
            value: this.state.note || "",
            onChange: (e) => this.setState({ note: e.target.value })
          }
        )
      ] }),
      /* @__PURE__ */ jsxs("div", { className: "small-4 column", children: [
        /* @__PURE__ */ jsx("label", { children: "Review On" }),
        /* @__PURE__ */ jsx(
          "input",
          {
            type: "date",
            value: this.state.review_on || "",
            onChange: (e) => this.setState({ review_on: e.target.value })
          }
        )
      ] })
    ] });
  },
  possibleSendEmail: function() {
    if (this.state.sendEmail) {
      const contacts = [
        ...this.props.contacts || [],
        ..._.get(this.props.possibleLoad, ["load", "contacts"], [])
      ];
      return /* @__PURE__ */ jsxs("div", { className: "exception-sender__email", children: [
        /* @__PURE__ */ jsxs("div", { className: "small-10 column", children: [
          /* @__PURE__ */ jsx(
            BouncesMessage,
            {
              recipients: maybeGetRecipients(this.props, this.state)
            }
          ),
          /* @__PURE__ */ jsx("label", { children: "Recipients" }),
          /* @__PURE__ */ jsx(
            EmailTypeAhead,
            {
              focusBehavior: "focus",
              onChange: this.recipientsChanged,
              selectByDefault: !noDefaultSenderEnabled(),
              recipients: maybeGetRecipients(this.props, this.state),
              contacts
            }
          )
        ] }),
        this.props.multipleExceptionMessagesEnabled && /* @__PURE__ */ jsxs("div", { className: "small-10 column", children: [
          /* @__PURE__ */ jsx("label", { children: "Template" }),
          /* @__PURE__ */ jsx(
            "select",
            {
              value: this.state.selectedTemplate || "",
              onChange: this.templateChanged,
              children: renderTemplateOptions(this.props)
            }
          )
        ] }),
        /* @__PURE__ */ jsxs("div", { className: "small-10 column", children: [
          /* @__PURE__ */ jsx("label", { children: "Subject" }),
          /* @__PURE__ */ jsx(
            "input",
            {
              type: "text",
              value: this.state.subject || "",
              onChange: (e) => this.setState({ subject: e.target.value })
            }
          )
        ] }),
        this.privateNoteFields(),
        /* @__PURE__ */ jsxs("div", { className: "small-10 column", children: [
          /* @__PURE__ */ jsx("label", { children: "Message" }),
          /* @__PURE__ */ jsx(
            "textarea",
            {
              rows: 12,
              value: this.state.body || "",
              onChange: (e) => this.setState({ body: e.target.value })
            }
          )
        ] }),
        this.possibleDocuments(),
        /* @__PURE__ */ jsxs("div", { className: "small-10 column exception-sender__documents-wrapper", children: [
          this.sendButton(),
          possibleCancel(this.props)
        ] })
      ] });
    }
  },
  possiblePrivateNote: function() {
    if (this.props.hasMore) {
      var completionContext = "and go to next group";
    } else {
      var completionContext = "and return to dashboard";
    }
    if (!this.state.sendEmail && !this.state.sendNoteToPayee) {
      return /* @__PURE__ */ jsxs("div", { className: "exception-sender__private-note-wrapper", children: [
        this.privateNoteFields(),
        /* @__PURE__ */ jsxs("div", { className: "small-10 column exception-sender__possible-completion-context-wrapper", children: [
          /* @__PURE__ */ jsx(
            DisablingButton,
            {
              disabled: this.state.saving,
              disabledText: "Saving...",
              onClick: this.pause,
              className: "button--progress",
              children: "Save Note"
            }
          ),
          /* @__PURE__ */ jsxs("div", { children: [
            /* @__PURE__ */ jsx("span", { className: "exception-sender__possible-completion-context", children: completionContext }),
            possibleCancel(this.props)
          ] })
        ] })
      ] });
    }
  },
  possibleSendNoteToPayee: function() {
    if (this.state.sendNoteToPayee) {
      return /* @__PURE__ */ jsxs("div", { children: [
        /* @__PURE__ */ jsxs("div", { className: "small-10 column", children: [
          /* @__PURE__ */ jsx("label", { children: "Message" }),
          /* @__PURE__ */ jsx(
            "textarea",
            {
              rows: 12,
              maxLength: 375,
              value: this.state.body || "",
              onChange: (e) => this.setState({ body: e.target.value })
            }
          )
        ] }),
        /* @__PURE__ */ jsxs("div", { className: "small-10 column", children: [
          this.sendNoteToPayeeButton(),
          possibleCancel(this.props)
        ] }),
        /* @__PURE__ */ jsx("div", { className: "small-10 column", children: "(Message will also be sent via email to facilitate resolution of exceptions)" })
      ] });
    }
  },
  possibleDocuments: function() {
    if (this.props.documents && this.props.documents.length > 0) {
      return /* @__PURE__ */ jsxs("div", { className: "small-10 column exception-sender__documents-wrapper", children: [
        /* @__PURE__ */ jsxs("label", { htmlFor: "", children: [
          /* @__PURE__ */ jsx("span", { children: "Documents to Attach" }),
          /* @__PURE__ */ jsx(
            "button",
            {
              className: "v3__button-outlined v3__button-small select-all",
              onClick: () => this.toggleAllDocuments(true),
              disabled: allDocumentsSelected(this.props, this.state),
              children: "Attach All"
            }
          ),
          /* @__PURE__ */ jsx(
            "button",
            {
              className: "v3__button-outlined v3__button-small select-all",
              onClick: () => this.toggleAllDocuments(false),
              disabled: noDocumentsSelected(this.props, this.state),
              children: "Detach All"
            }
          )
        ] }),
        /* @__PURE__ */ jsx("div", { className: "exception-sender__documents", children: _.map(this.props.documents, this.showDocument) })
      ] });
    }
  },
  sendButton: function() {
    var disabledText = this.state.saving ? "Sending..." : "Enter recipients to send";
    return /* @__PURE__ */ jsx(
      DisablingButton,
      {
        disabled: this.state.saving || !validEmail(this.state),
        disabledText,
        className: "button--progress",
        onClick: this.sendMessage,
        children: "Send Message"
      }
    );
  },
  sendNoteToPayeeButton: function() {
    var disabledText = this.state.saving ? "Sending..." : "Enter recipients to send";
    return /* @__PURE__ */ jsx(
      DisablingButton,
      {
        disabled: this.state.saving || !validPayeeMessage(this.state),
        disabledText,
        className: "button--progress",
        onClick: this.sendNoteToPayee,
        children: "Send Message"
      }
    );
  },
  recipientsChanged: function(recipients) {
    this.setState({
      recipients: recipients.join(", ")
    });
  },
  pause: function() {
    this.setState({ saving: true });
    var promise;
    if (this.props.exceptionedItemId) {
      promise = Api.ExceptionedItems.pause(
        this.props.exceptionedItemId,
        this.state.note,
        this.state.review_on,
        this.props.emailMessageId
      );
    } else if (this.props.emailMessageId) {
      promise = Api.ExceptionedItems.pauseEmailMessage(
        this.props.emailMessageId,
        this.state.note,
        this.state.review_on
      );
    } else {
      promise = Api.ExceptionedItems.pauseDocumentGroup(
        this.props.documentGroupId,
        this.state.note,
        this.state.review_on
      );
    }
    promise.then(
      (result) => {
        this.setState({ saving: false });
        onComplete(this.props);
        return result;
      },
      (error) => {
        this.setState({ saving: false });
        return error;
      }
    );
  },
  sendNoteToPayee: function() {
    this.setState({ saving: true });
    const email_id = this.props.emailMessageId || this.props.parentId || this.props.parent.id;
    Api.Email.sendRejectionNote({
      id: email_id,
      recipients: this.props.carrierInvoice.payments_network_payee_email_address,
      subject: this.state.subject,
      exceptioned_item_id: this.props.exceptionedItemId,
      document_ids: selectedDocumentIds(this.props, this.state),
      document_group_id: this.props.documentGroupId,
      parent_id: this.props.parentId || this.props.parent.id,
      note: this.state.note,
      review_on: this.state.review_on,
      mark_parent_complete: this.props.markParentComplete,
      body: this.state.body
    }).then(
      (result) => {
        this.setState({ saving: false });
        this.props.onComplete();
        return result;
      },
      (error) => {
        this.setState({ saving: false });
        return Promise.reject(error);
      }
    );
  },
  sendMessage: function() {
    var _a;
    this.setState({ saving: true });
    Api.Email.send({
      subject: this.state.subject,
      recipients: allRecipients(this.state),
      exceptioned_item_id: this.props.exceptionedItemId,
      document_ids: selectedDocumentIds(this.props, this.state),
      document_group_id: this.props.documentGroupId,
      parent_id: this.props.parentId || ((_a = this.props.parent) == null ? void 0 : _a.id),
      note: this.state.note,
      review_on: this.state.review_on,
      mark_parent_complete: this.props.markParentComplete,
      body: this.state.body
    }).then(
      (result) => {
        this.setState({ saving: false });
        this.props.onComplete();
        return result;
      },
      (error) => {
        this.setState({ saving: false });
        return Promise.reject(error);
      }
    );
  },
  showDocument: function(document) {
    var page = _.first(document.pages);
    var classes = classNames({
      "exception-sender__document": true,
      "exception-sender__selected-document": !this.state[document.id]
    });
    return /* @__PURE__ */ jsx(
      "div",
      {
        className: classes,
        onClick: () => {
          this.documentToggled(document);
        },
        children: /* @__PURE__ */ jsx(
          DocumentThumbnail,
          {
            document,
            firstPageOnly: true,
            pageSelected: () => {
            },
            selectedPages: [page],
            hasReferenceMatch: false,
            missingReferenceMatch: false,
            isPodForLoad: false
          }
        )
      },
      "document-" + document.id
    );
  },
  toggleAllDocuments: function(selected) {
    var newState = {};
    _.each(this.props.documents, function(doc) {
      newState[doc.id] = !selected;
    });
    this.setState(newState);
  },
  templateChanged: function(event) {
    const templateId = event.target.value;
    const email = getEmailFromTemplate(this.props, templateId, {
      selectedTemplate: "",
      subject: this.props.defaultEmail.subject,
      body: this.props.defaultEmail.body
    });
    this.setState(email);
  }
});
export default ExceptionSender;
